import {useTranslation} from "react-i18next";
import {RegisterForm} from "../../components/guest/authentication/RegisterForm";
import {FormLayout} from "../../components/guest/layout/form/FormLayout";

export const Register = () => {
    const {t} = useTranslation("register");

    return (
        <FormLayout
            eyebrow={t("register:page-eyebrow")}
            title={<>
                {t("register:page-title-1")}<br/>
                {t("register:page-title-2")}<br/>
                <em>{t("register:page-title-3")}</em>
            </>}
            text={t("register:page-text")}>
            <RegisterForm/>
        </FormLayout>
    );
};